export default __webpack_public_path__ + "static/media/sac-aspca-logo.bb7d7267.png";